<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      color=""
    >
    <!-- color="#21445c" -->

      <v-list color="ffffff" dense>
        <v-list-item @click="toMyInfosPage" :input-value="isActive('myinfos')" color="primary" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-information-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Meus Dados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toDashboardPage" :input-value="isActive('dashboards')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-chart-timeline-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Gráficos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toConfigPage" :input-value="isActive('configs')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-cogs</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Configurações</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toRealStatePage" :input-value="isActive('realStates')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Imobiliárias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toUsersPage" :input-value="isActive('users')" color="primary" v-if="isAdminOrManager" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-account-edit</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toClientsPage" :input-value="isActive('clients', 'createClient', 'editClient')" color="primary" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-account-details</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Cadastro de clientes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toPropertyPage" :input-value="isActive('properties')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-office-building</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Empreendimentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toSizeLotPage" :input-value="isActive('sizeLots')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-format-size</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Tam. Empreendimentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toReservePage" :input-value="isActive('reserves')" color="primary" link v-if="showMenuReserves">
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-file-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Cadastro de reservas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toRequestPage" :input-value="isActive('requests')" color="primary" v-if="isAdmin" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-content-duplicate</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Devoluções/Abatimentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toPoliticPage" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-book-open-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Políticas de Privacidade</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div v-if="showMenusSienge">
          <v-divider></v-divider>
          <v-list-item @click="toSiengeClientsPage" :input-value="isActive('sienge-clients')" color="primary" v-if="isAdmin" link>
            <v-list-item-action>
              <v-icon color="black darken-2">mdi-account-convert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="">Clientes Sienge</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="toSiengeCreditorsPage" :input-value="isActive('sienge-creditors')" color="primary" v-if="isAdmin" link>
            <v-list-item-action>
              <v-icon color="black darken-2">mdi-account-convert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="">Credores Sienge</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="toProfessionPage" :input-value="isActive('professions')" color="primary" v-if="isAdmin" link>
            <v-list-item-action>
              <v-icon color="black darken-2">mdi-account-convert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="">Profissão Sienge</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="toClientChangePage" :input-value="isActive('client-changes')" color="primary" v-if="isAdmin" link>
            <v-list-item-action>
              <v-icon color="black darken-2">mdi-account-reactivate-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="">Clientes Modificados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-divider></v-divider>
        <v-list-item @click="logout" link>
          <v-list-item-action>
            <v-icon color="black darken-2">mdi-account-arrow-right-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="">Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="margin-top:100px;" >versão 2.3.0</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <p></p>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="title-bold">Plataforma Idealiza</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <modal-privacy></modal-privacy>

    <v-btn
      fab
      dark
      color="green"
      class="mb-10"
      absolute
      bottom
      left
      @click="toWhatsAppPage"
    >
      <v-icon>mdi-whatsapp</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import store from '@/store'
import ModalPrivacy from '@/components/politics/ModalPrivacy'
import api from '@/services/api'
import message from '@/utils/message'

export default {
  name: 'app-layout',
  components: {
    ModalPrivacy
  },
  props: {
    source: String
  },
  data () {
    return {
      drawer: false
    }
  },

  computed: {
    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    },
    isAdminOrManager () {
      return store.getters.user.userType !== null && (store.getters.user.userType.id === 1 || store.getters.user.userType.id === 3)
    },
    showMenuReserves () {
      return store.getters.config.showMenuReserves !== null && store.getters.config.showMenuReserves
    },
    showMenusSienge () {
      return store.getters.config.syncSienge !== null && store.getters.config.syncSienge
    }
  },

  created () {
    this.getConfigs()
  },

  methods: {
    async getConfigs () {
      try {
        const { data } = await api.get('/configs')
        this.$store.commit('setShowMenuReserve', data[3].value)
        this.$store.commit('setSyncSienge', data[2].value)
        this.$store.commit('setDocObrigatory', data[1].value)
        this.$store.commit('setConjugateData', data[0].value)
      } catch (error) {
        message.error('Erro ao buscar configurações')
      }
    },
    isActive (...routeNames) {
      return routeNames.includes(this.$route.name)
    },
    toDashboardPage () {
      this.$router.push({ name: 'dashboards' })
    },
    toClientsPage () {
      this.$router.push({ name: 'clients' })
    },
    toSiengeClientsPage () {
      this.$router.push({ name: 'sienge-clients' })
    },
    toSiengeCreditorsPage () {
      this.$router.push({ name: 'sienge-creditors' })
    },
    toUsersPage () {
      this.$router.push({ name: 'users' })
    },
    toRealStatePage () {
      this.$router.push({ name: 'realStates' })
    },
    toPropertyPage () {
      this.$router.push({ name: 'properties' })
    },
    toReservePage () {
      this.$router.push({ name: 'reserves' })
    },
    toSizeLotPage () {
      this.$router.push({ name: 'sizeLots' })
    },
    toMyInfosPage () {
      this.$router.push({ name: 'myinfos' })
    },
    toConfigPage () {
      this.$router.push({ name: 'configs' })
    },
    toProfessionPage () {
      this.$router.push({ name: 'professions' })
    },
    toRequestPage () {
      this.$router.push({ name: 'requests' })
    },
    toClientChangePage () {
      this.$router.push({ name: 'client-changes' })
    },
    toPoliticPage () {
      let routeData = this.$router.resolve({ name: 'politics' })
      return window.open(routeData.href, '_blank')
    },
    toWhatsAppPage () {
      return window.open('https://wa.me/5512991040247', '_blank')
    },
    async logout () {
      this.$store.commit('setToken', null)
      this.$store.commit('setUserType', null)
      this.$store.commit('setBroker', null)
      this.$store.commit('setRealState', null)
      this.$store.commit('setId', null)
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
  .item {
    color: #ffff !important;
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AppLayout.vue